import(/* webpackMode: "eager", webpackExports: ["ScraperApp"] */ "/app/src/components/ScraperApp.tsx");
